import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useRef } from "react";

import { ScoutChatMessage } from "../hooks/useScoutChatWithMocks";
import { AgentMessage } from "./AgentMessage";
import { ScoutInput } from "./ScoutInput";
import { UserMessage } from "./UserMessage";

export function ChatChrome({
  messages,
  onSubmit,
  onAbort,
  isSending,
}: {
  messages: ScoutChatMessage[];
  onSubmit: (text: string) => Promise<void>;
  onAbort: () => void;
  isSending: boolean;
}) {
  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: 0,
        maxWidth: "1000px",
        width: "100%",
      }}
    >
      <MessageList messages={messages} />
      <Box
        component="footer"
        sx={{
          flexShrink: 0,
          pt: 1,
          p: 2,
        }}
      >
        <ScoutInput onSubmit={onSubmit} onAbort={onAbort} isSending={isSending} />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", textAlign: "center", mt: 1.5, px: 2 }}
        >
          Scout is AI and can make mistakes. Please double-check responses.
        </Typography>
      </Box>
    </Stack>
  );
}

function MessageList({ messages }: { messages: ScoutChatMessage[] }) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {messages.map((m) =>
        m.role === "user" ? (
          <UserMessage key={m.id} message={m} />
        ) : (
          <AgentMessage key={m.id} message={m} />
        )
      )}
      <div ref={bottomRef} />
    </Box>
  );
}
